<script>
  import _ from 'lodash'
  import * as moment from 'moment'
  import VueTypes from 'vue-types'

  const isNullable = { validator: (value) => value === null }

  export default {
    name: 'ProfitAndLoss',
    props: {
      unit: VueTypes.number,
      negativeMark: VueTypes.string,
      walfareRate: VueTypes.number,
      serviceLife: VueTypes.number,
      launchYear: VueTypes.number,
      launchMonth: VueTypes.number,
      startYear: VueTypes.number,
      startMonth: VueTypes.number,
      before: VueTypes.shape({
        personnel: VueTypes.number,
        annualIncome: VueTypes.number,
        advertisingExpense: VueTypes.number,
        advertisingStartMonth: VueTypes.number,
        capitalInv: VueTypes.number,
        nonAssetCapitalInv: VueTypes.number,
        rents: VueTypes.number,
        otherExpense: VueTypes.number,
      }),
      year1: VueTypes.shape({
        main: VueTypes.shape({
          price: VueTypes.number,
          sellVolumePerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          sellVolumePerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
          salesMargin: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerItem: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
        }),
        sub: VueTypes.shape({
          price: VueTypes.number,
          sellVolumePerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          sellVolumePerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
          salesMargin: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerItem: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
        }),
        sub2: VueTypes.shape({
          price: VueTypes.number,
          sellVolumePerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          sellVolumePerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
          salesMargin: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerItem: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
        }),
        personnel: VueTypes.number,
        annualIncome: VueTypes.number,
        advertisingExpense: VueTypes.number,
        capitalInv: VueTypes.number,
        nonAssetCapitalInv: VueTypes.number,
        rents: VueTypes.number,
        otherExpense: VueTypes.number,
      }),
      year2: VueTypes.shape({
        main: VueTypes.shape({
          price: VueTypes.number,
          sellVolumePerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          sellVolumePerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
          salesMargin: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerItem: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
        }),
        sub: VueTypes.shape({
          price: VueTypes.number,
          sellVolumePerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          sellVolumePerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
          salesMargin: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerItem: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
        }),
        sub2: VueTypes.shape({
          price: VueTypes.number,
          sellVolumePerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          sellVolumePerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
          salesMargin: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerItem: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
        }),
        personnel: VueTypes.number,
        annualIncome: VueTypes.number,
        advertisingExpense: VueTypes.number,
        capitalInv: VueTypes.number,
        nonAssetCapitalInv: VueTypes.number,
        rents: VueTypes.number,
        otherExpense: VueTypes.number,
      }),
      year3: VueTypes.shape({
        main: VueTypes.shape({
          price: VueTypes.number,
          sellVolumePerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          sellVolumePerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
          salesMargin: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerItem: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
        }),
        sub: VueTypes.shape({
          price: VueTypes.number,
          sellVolumePerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          sellVolumePerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
          salesMargin: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerItem: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
        }),
        sub2: VueTypes.shape({
          price: VueTypes.number,
          sellVolumePerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          sellVolumePerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
          salesMargin: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerItem: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerYear: VueTypes.oneOfType([VueTypes.number, isNullable.value]),
          productCostPerMonths: VueTypes.arrayOf(VueTypes.oneOfType([VueTypes.number, isNullable.value])),
        }),
        personnel: VueTypes.number,
        annualIncome: VueTypes.number,
        advertisingExpense: VueTypes.number,
        capitalInv: VueTypes.number,
        nonAssetCapitalInv: VueTypes.number,
        rents: VueTypes.number,
        otherExpense: VueTypes.number,
      }),
    },

    computed: {

      // 年月

      // 販売開始までの月数
      beforeMonths () {
        return (this.launchYear * 12 + this.launchMonth) - (this.startYear * 12 + this.startMonth)
      },

      endYear () {
        return this._baseDate().add({ year: 0, month: -1 }).year()
      },
      endMonth () {
        return this._baseDate().add({ year: 0, month: -1 }).month() + 1
      },
      startYear1 () {
        return this._baseDate().add({ year: 0, month: 0 }).year()
      },
      startMonth1 () {
        return this._baseDate().add({ year: 0, month: 0 }).month() + 1
      },
      endYear1 () {
        return this._baseDate().add({ year: 1, month: -1 }).year()
      },
      endMonth1 () {
        return this._baseDate().add({ year: 1, month: -1 }).month() + 1
      },
      startYear2 () {
        return this._baseDate().add({ year: 1, month: 0 }).year()
      },
      startMonth2 () {
        return this._baseDate().add({ year: 1, month: 0 }).month() + 1
      },
      endYear2 () {
        return this._baseDate().add({ year: 2, month: -1 }).year()
      },
      endMonth2 () {
        return this._baseDate().add({ year: 2, month: -1 }).month() + 1
      },
      startYear3 () {
        return this._baseDate().add({ year: 2, month: 0 }).year()
      },
      startMonth3 () {
        return this._baseDate().add({ year: 2, month: 0 }).month() + 1
      },
      endYear3 () {
        return this._baseDate().add({ year: 3, month: -1 }).year()
      },
      endMonth3 () {
        return this._baseDate().add({ year: 3, month: -1 }).month() + 1
      },

      // 売上(主)

      beforeMainSales () {
        return 0
      },
      year1MainSales () {
        return this.year1.main.price * this.year1MainSellVolume * (100 - this.year1.main.salesMargin) / 100
      },
      year2MainSales () {
        return this.year2.main.price * this.year2MainSellVolume * (100 - this.year2.main.salesMargin) / 100
      },
      year3MainSales () {
        return this.year3.main.price * this.year3MainSellVolume * (100 - this.year3.main.salesMargin) / 100
      },

      // 売上(副)

      beforeSubSales () {
        return 0
      },
      year1SubSales () {
        return this.year1.sub.price * this.year1SubSellVolume * (100 - this.year1.sub.salesMargin) / 100
      },
      year2SubSales () {
        return this.year2.sub.price * this.year2SubSellVolume * (100 - this.year2.sub.salesMargin) / 100
      },
      year3SubSales () {
        return this.year3.sub.price * this.year3SubSellVolume * (100 - this.year3.sub.salesMargin) / 100
      },

      // 売上(副2)

      beforeSub2Sales () {
        return 0
      },
      year1Sub2Sales () {
        return this.year1.sub2.price * this.year1Sub2SellVolume * (100 - this.year1.sub2.salesMargin) / 100
      },
      year2Sub2Sales () {
        return this.year2.sub2.price * this.year2Sub2SellVolume * (100 - this.year2.sub2.salesMargin) / 100
      },
      year3Sub2Sales () {
        return this.year3.sub2.price * this.year3Sub2SellVolume * (100 - this.year3.sub2.salesMargin) / 100
      },

      beforeTotalSales () {
        return this.beforeMainSales + this.beforeSubSales + this.beforeSub2Sales
      },

      year1TotalSales () {
        return this.year1MainSales + this.year1SubSales + this.year1Sub2Sales
      },
      year2TotalSales () {
        return this.year2MainSales + this.year2SubSales + this.year2Sub2Sales
      },
      year3TotalSales () {
        return this.year3MainSales + this.year3SubSales + this.year3Sub2Sales
      },

      // 販売数(主)

      year1MainSellVolume () {
        if (this.year1.main.sellVolumePerYear !== null) {
          // 年間
          return this.year1.main.sellVolumePerYear
        } else {
          // 月別
          return _.sum(this.year1.main.sellVolumePerMonths)
        }
      },

      year2MainSellVolume () {
        if (this.year2.main.sellVolumePerYear !== null) {
          // 年間
          return this.year2.main.sellVolumePerYear
        } else {
          // 月別
          return _.sum(this.year2.main.sellVolumePerMonths)
        }
      },

      year3MainSellVolume () {
        if (this.year3.main.sellVolumePerYear !== null) {
          // 年間
          return this.year3.main.sellVolumePerYear
        } else {
          // 月別
          return _.sum(this.year3.main.sellVolumePerMonths)
        }
      },

      // 販売数(副)

      year1SubSellVolume () {
        if (this.year1.sub.sellVolumePerYear !== null) {
          // 年間
          return this.year1.sub.sellVolumePerYear
        } else {
          // 月別
          return _.sum(this.year1.sub.sellVolumePerMonths)
        }
      },

      year2SubSellVolume () {
        if (this.year2.sub.sellVolumePerYear !== null) {
          // 年間
          return this.year2.sub.sellVolumePerYear
        } else {
          // 月別
          return _.sum(this.year2.sub.sellVolumePerMonths)
        }
      },

      year3SubSellVolume () {
        if (this.year3.sub.sellVolumePerYear !== null) {
          // 年間
          return this.year3.sub.sellVolumePerYear
        } else {
          // 月別
          return _.sum(this.year3.sub.sellVolumePerMonths)
        }
      },

      // 販売数(副2)

      year1Sub2SellVolume () {
        if (this.year1.sub2.sellVolumePerYear !== null) {
          // 年間
          return this.year1.sub2.sellVolumePerYear
        } else {
          // 月別
          return _.sum(this.year1.sub2.sellVolumePerMonths)
        }
      },

      year2Sub2SellVolume () {
        if (this.year2.sub2.sellVolumePerYear !== null) {
          // 年間
          return this.year2.sub2.sellVolumePerYear
        } else {
          // 月別
          return _.sum(this.year2.sub2.sellVolumePerMonths)
        }
      },

      year3Sub2SellVolume () {
        if (this.year3.sub2.sellVolumePerYear !== null) {
          // 年間
          return this.year3.sub2.sellVolumePerYear
        } else {
          // 月別
          return _.sum(this.year3.sub2.sellVolumePerMonths)
        }
      },

      // 売上原価(主)

      beforeMainSalesCost () {
        return 0
      },
      year1MainSalesCost () {
        if (this.year1.main.productCostPerItem !== null) {
          // 1個あたり
          return this.year1.main.productCostPerItem * this.year1MainSellVolume
        } else if (this.year1.main.productCostPerYear !== null) {
          // 年別
          return this.year1.main.productCostPerYear
        } else {
          // 月別
          return _.sum(this.year1.main.productCostPerMonths)
        }
      },
      year2MainSalesCost () {
        if (this.year2.main.productCostPerItem !== null) {
          // 1個あたり
          return this.year2.main.productCostPerItem * this.year2MainSellVolume
        } else if (this.year2.main.productCostPerYear !== null) {
          // 年別
          return this.year2.main.productCostPerYear
        } else {
          // 月別
          return _.sum(this.year2.main.productCostPerMonths)
        }
      },
      year3MainSalesCost () {
        if (this.year3.main.productCostPerItem !== null) {
          // 1個あたり
          return this.year3.main.productCostPerItem * this.year3MainSellVolume
        } else if (this.year3.main.productCostPerYear !== null) {
          // 年別
          return this.year3.main.productCostPerYear
        } else {
          // 月別
          return _.sum(this.year3.main.productCostPerMonths)
        }
      },

      // 売上原価(副)

      beforeSubSalesCost () {
        return 0
      },
      year1SubSalesCost () {
        if (this.year1.sub.productCostPerItem !== null) {
          // 1個あたり
          return this.year1.sub.productCostPerItem * this.year1SubSellVolume
        } else if (this.year1.sub.productCostPerYear !== null) {
          // 年別
          return this.year1.sub.productCostPerYear
        } else {
          // 月別
          return _.sum(this.year1.sub.productCostPerMonths)
        }
      },
      year2SubSalesCost () {
        if (this.year2.sub.productCostPerItem !== null) {
          // 1個あたり
          return this.year2.sub.productCostPerItem * this.year2SubSellVolume
        } else if (this.year2.sub.productCostPerYear !== null) {
          // 年別
          return this.year2.sub.productCostPerYear
        } else {
          // 月別
          return _.sum(this.year2.sub.productCostPerMonths)
        }
      },
      year3SubSalesCost () {
        if (this.year3.sub.productCostPerItem !== null) {
          // 1個あたり
          return this.year3.sub.productCostPerItem * this.year3SubSellVolume
        } else if (this.year3.sub.productCostPerYear !== null) {
          // 年別
          return this.year3.sub.productCostPerYear
        } else {
          // 月別
          return _.sum(this.year3.sub.productCostPerMonths)
        }
      },

      // 売上原価(副2)

      beforeSub2SalesCost () {
        return 0
      },
      year1Sub2SalesCost () {
        if (this.year1.sub2.productCostPerItem !== null) {
          // 1個あたり
          return this.year1.sub2.productCostPerItem * this.year1Sub2SellVolume
        } else if (this.year1.sub2.productCostPerYear !== null) {
          // 年別
          return this.year1.sub2.productCostPerYear
        } else {
          // 月別
          return _.sum(this.year1.sub2.productCostPerMonths)
        }
      },
      year2Sub2SalesCost () {
        if (this.year2.sub2.productCostPerItem !== null) {
          // 1個あたり
          return this.year2.sub2.productCostPerItem * this.year2Sub2SellVolume
        } else if (this.year2.sub2.productCostPerYear !== null) {
          // 年別
          return this.year2.sub2.productCostPerYear
        } else {
          // 月別
          return _.sum(this.year2.sub2.productCostPerMonths)
        }
      },
      year3Sub2SalesCost () {
        if (this.year3.sub2.productCostPerItem !== null) {
          // 1個あたり
          return this.year3.sub2.productCostPerItem * this.year3Sub2SellVolume
        } else if (this.year3.sub2.productCostPerYear !== null) {
          // 年別
          return this.year3.sub2.productCostPerYear
        } else {
          // 月別
          return _.sum(this.year3.sub2.productCostPerMonths)
        }
      },

      // 売上原価

      beforeTotalSalesCost () {
        return this.beforeMainSalesCost + this.beforeSubSalesCost + this.beforeSub2SalesCost
      },
      year1TotalSalesCost () {
        return this.year1MainSalesCost + this.year1SubSalesCost + this.year1Sub2SalesCost
      },
      year2TotalSalesCost () {
        return this.year2MainSalesCost + this.year2SubSalesCost + this.year2Sub2SalesCost
      },
      year3TotalSalesCost () {
        return this.year3MainSalesCost + this.year3SubSalesCost + this.year3Sub2SalesCost
      },

      // 人件費

      beforePersonnelExpense () {
        if (this.beforeMonths !== 0) {
          return this.before.annualIncome * this.before.personnel * this.walfareRate / 12 * this.beforeMonths
        } else {
          return 0
        }
      },
      year1PersonnelExpense () {
        return this.year1.annualIncome * this.year1.personnel * this.walfareRate
      },
      year2PersonnelExpense () {
        return this.year2.annualIncome * this.year2.personnel * this.walfareRate
      },
      year3PersonnelExpense () {
        return this.year3.annualIncome * this.year3.personnel * this.walfareRate
      },

      // 広告宣伝費

      beforeAdvertisingExpense () {
        return this.before.advertisingExpense
      },
      year1AdvertisingExpense () {
        return this.year1.advertisingExpense
      },
      year2AdvertisingExpense () {
        return this.year2.advertisingExpense
      },
      year3AdvertisingExpense () {
        return this.year3.advertisingExpense
      },

      // 設備投資費

      year1InvestmentCost () {
        const life = this.serviceLife || 1
        return (this.before.capitalInv / life) + (this.year1.capitalInv / life)
      },
      year2InvestmentCost () {
        const life = this.serviceLife || 1
        let cost = 0
        if (this.serviceLife > 1) {
          cost = this.year1InvestmentCost
        }
        return cost + (this.year2.capitalInv / life)
      },
      year3InvestmentCost () {
        const life = this.serviceLife || 1
        let cost = 0
        if (this.serviceLife > 2) {
          cost = this.year1InvestmentCost
        }
        if (this.serviceLife > 1) {
          cost = this.year2InvestmentCost
        }
        return cost + (this.year3.capitalInv / life)
      },

      beforeNonAssetInvestmentCost () {
        return this.before.nonAssetCapitalInv
      },
      year1NonAssetInvestmentCost () {
        return this.year1.nonAssetCapitalInv
      },
      year2NonAssetInvestmentCost () {
        return this.year2.nonAssetCapitalInv
      },
      year3NonAssetInvestmentCost () {
        return this.year3.nonAssetCapitalInv
      },

      beforeInvestmentCostForFunds () {
        return this.before.capitalInv + this.before.nonAssetCapitalInv
      },
      year1InvestmentCostForFunds () {
        return this.year1.capitalInv + this.year1.nonAssetCapitalInv
      },
      year2InvestmentCostForFunds () {
        return this.year2.capitalInv + this.year2.nonAssetCapitalInv
      },
      year3InvestmentCostForFunds () {
        return this.year3.capitalInv + this.year3.nonAssetCapitalInv
      },

      // 生活経費

      beforeLifeExpense () {
        if (this.beforeMonths !== 0) {
          return this.before.rents / 12 * this.beforeMonths
        } else {
          return 0
        }
      },
      year1LifeExpense () {
        return this.year1.rents
      },
      year2LifeExpense () {
        return this.year2.rents
      },
      year3LifeExpense () {
        return this.year3.rents
      },

      // その他経費

      beforeOtherExpense () {
        if (this.beforeMonths !== 0) {
          return this.before.otherExpense / 12 * this.beforeMonths
        } else {
          return 0
        }
      },
      year1OtherExpense () {
        return this.year1.otherExpense
      },
      year2OtherExpense () {
        return this.year2.otherExpense
      },
      year3OtherExpense () {
        return this.year3.otherExpense
      },

      // 販売管理費合計

      beforeSalesManagementCost () {
        return this.beforePersonnelExpense + this.beforeAdvertisingExpense + this.beforeNonAssetInvestmentCost + this.beforeLifeExpense + this.beforeOtherExpense
      },

      year1SalesManagementCost () {
        return this.year1PersonnelExpense + this.year1AdvertisingExpense + this.year1InvestmentCost + this.year1NonAssetInvestmentCost + this.year1LifeExpense + this.year1OtherExpense
      },

      year2SalesManagementCost () {
        return this.year2PersonnelExpense + this.year2AdvertisingExpense + this.year2InvestmentCost + this.year2NonAssetInvestmentCost + this.year2LifeExpense + this.year2OtherExpense
      },

      year3SalesManagementCost () {
        return this.year3PersonnelExpense + this.year3AdvertisingExpense + this.year3InvestmentCost + this.year3NonAssetInvestmentCost + this.year3LifeExpense + this.year3OtherExpense
      },

      beforeSalesManagementCostForFunds () {
        return this.beforePersonnelExpense + this.beforeAdvertisingExpense + this.beforeInvestmentCostForFunds + this.beforeLifeExpense + this.beforeOtherExpense
      },

      year1SalesManagementCostForFunds () {
        return this.year1PersonnelExpense + this.year1AdvertisingExpense + this.year1InvestmentCostForFunds + this.year1LifeExpense + this.year1OtherExpense
      },

      year2SalesManagementCostForFunds () {
        return this.year2PersonnelExpense + this.year2AdvertisingExpense + this.year2InvestmentCostForFunds + this.year2LifeExpense + this.year2OtherExpense
      },

      year3SalesManagementCostForFunds () {
        return this.year3PersonnelExpense + this.year3AdvertisingExpense + this.year3InvestmentCostForFunds + this.year3LifeExpense + this.year3OtherExpense
      },


      // 営業利益

      beforeOperatingProfitTotal () {
        return this.beforeTotalSales - this.beforeTotalSalesCost - this.beforeSalesManagementCost
      },

      year1OperatingProfitTotal () {
        return this.year1TotalSales - this.year1TotalSalesCost - this.year1SalesManagementCost
      },

      year2OperatingProfitTotal () {
        return this.year2TotalSales - this.year2TotalSalesCost - this.year2SalesManagementCost
      },

      year3OperatingProfitTotal () {
        return this.year3TotalSales - this.year3TotalSalesCost - this.year3SalesManagementCost
      },

      beforeOperatingProfitTotalForFunds () {
        return this.beforeTotalSales - this.beforeTotalSalesCost - this.beforeSalesManagementCostForFunds
      },

      year1OperatingProfitTotalForFunds () {
        return this.year1TotalSales - this.year1TotalSalesCost - this.year1SalesManagementCostForFunds
      },

      year2OperatingProfitTotalForFunds () {
        return this.year2TotalSales - this.year2TotalSalesCost - this.year2SalesManagementCostForFunds
      },

      year3OperatingProfitTotalForFunds () {
        return this.year3TotalSales - this.year3TotalSalesCost - this.year3SalesManagementCostForFunds
      },
    },

    methods: {
      //from filters
      currencyFormat (val, fixed = 1, negativeMark = '△') {
        const num = parseInt(val, 10)
        if (isNaN(num)) {
          return val
        }

        const delimiterFormat = /\B(?=(\d{3})+(?!\d))/g
        if (val >= 0) {
          return val.toFixed(fixed).replace(delimiterFormat, ',')
        } else {
          return negativeMark + ' ' + Math.abs(val).toFixed(fixed).toString().replace(delimiterFormat, ',')
        }
      },
      _startDate () {
        return moment(`${this.startYear}-${this.startMonth}`, 'YYYY-MM').startOf('month')
      },

      _baseDate () {
        return moment(`${this.launchYear}-${this.launchMonth}`, 'YYYY-MM').startOf('month')
      },

      toSigned (val) {
        if (val >= 0 || isNaN(val)) {
          return val.toFixed(1)
        } else {
          return this.negativeMark + ' ' + Math.abs(val).toFixed(1)
        }
      },

      // 月別売上(主)

      // 指定月の売上(主)を返す
      // ・年間販売計画の場合、12ヶ月で割ったもの
      // ・月間販売計画の場合、その月の販売数x単価
      // @params month :: 月(0 origin)
      beforeMainSalesInMonth (month) {
        return 0
      },

      year1MainSalesInMonth (month) {
        return this.year1.main.price * this.year1MainSellVolumeInMonth(month) * (100 - this.year1.main.salesMargin) / 100
      },

      year2MainSalesInMonth (month) {
        return this.year2.main.price * this.year2MainSellVolumeInMonth(month) * (100 - this.year2.main.salesMargin) / 100
      },

      year3MainSalesInMonth (month) {
        return this.year3.main.price * this.year3MainSellVolumeInMonth(month) * (100 - this.year3.main.salesMargin) / 100
      },

      // 月別売上(副)

      beforeSubSalesInMonth (month) {
        return 0
      },

      year1SubSalesInMonth (month) {
        return this.year1.sub.price * this.year1SubSellVolumeInMonth(month) * (100 - this.year1.sub.salesMargin) / 100
      },

      year2SubSalesInMonth (month) {
        return this.year2.sub.price * this.year2SubSellVolumeInMonth(month) * (100 - this.year2.sub.salesMargin) / 100
      },

      year3SubSalesInMonth (month) {
        return this.year3.sub.price * this.year3SubSellVolumeInMonth(month) * (100 - this.year3.sub.salesMargin) / 100
      },

      // 月別売上(副2)

      beforeSub2SalesInMonth (month) {
        return 0
      },

      year1Sub2SalesInMonth (month) {
        return this.year1.sub2.price * this.year1Sub2SellVolumeInMonth(month) * (100 - this.year1.sub2.salesMargin) / 100
      },

      year2Sub2SalesInMonth (month) {
        return this.year2.sub2.price * this.year2Sub2SellVolumeInMonth(month) * (100 - this.year2.sub2.salesMargin) / 100
      },

      year3Sub2SalesInMonth (month) {
        return this.year3.sub2.price * this.year3Sub2SellVolumeInMonth(month) * (100 - this.year3.sub2.salesMargin) / 100
      },

      // 月別売上(合計)

      beforeTotalSalesInMonth (month) {
        return this.beforeMainSalesInMonth(month) + this.beforeSubSalesInMonth(month) + this.beforeSub2SalesInMonth(month)
      },

      year1TotalSalesInMonth (month) {
        return this.year1MainSalesInMonth(month) + this.year1SubSalesInMonth(month) + this.year1Sub2SalesInMonth(month)
      },

      year2TotalSalesInMonth (month) {
        return this.year2MainSalesInMonth(month) + this.year2SubSalesInMonth(month) + this.year2Sub2SalesInMonth(month)
      },

      year3TotalSalesInMonth (month) {
        return this.year3MainSalesInMonth(month) + this.year3SubSalesInMonth(month) + this.year3Sub2SalesInMonth(month)
      },

      // 月別販売数(主)

      year1MainSellVolumeInMonth (month) {
        if (this.year1.main.sellVolumePerYear !== null) {
          // 年間
          return Math.round(this.year1.main.sellVolumePerYear / 12)
        } else {
          // 月別
          return this.year1.main.sellVolumePerMonths[month]
        }
      },

      year2MainSellVolumeInMonth (month) {
        if (this.year2.main.sellVolumePerYear !== null) {
          // 年間
          return Math.round(this.year2.main.sellVolumePerYear / 12)
        } else {
          // 月別
          return this.year2.main.sellVolumePerMonths[month]
        }
      },

      year3MainSellVolumeInMonth (month) {
        if (this.year3.main.sellVolumePerYear !== null) {
          // 年間
          return Math.round(this.year3.main.sellVolumePerYear / 12)
        } else {
          // 月別
          return this.year3.main.sellVolumePerMonths[month]
        }
      },

      // 月別販売数(副)

      year1SubSellVolumeInMonth (month) {
        if (this.year1.sub.sellVolumePerYear !== null) {
          // 年間
          return Math.round(this.year1.sub.sellVolumePerYear / 12)
        } else {
          // 月別
          return this.year1.sub.sellVolumePerMonths[month]
        }
      },

      year2SubSellVolumeInMonth (month) {
        if (this.year2.sub.sellVolumePerYear !== null) {
          // 年間
          return Math.round(this.year2.sub.sellVolumePerYear / 12)
        } else {
          // 月別
          return this.year2.sub.sellVolumePerMonths[month]
        }
      },

      year3SubSellVolumeInMonth (month) {
        if (this.year3.sub.sellVolumePerYear !== null) {
          // 年間
          return Math.round(this.year3.sub.sellVolumePerYear / 12)
        } else {
          // 月別
          return this.year3.sub.sellVolumePerMonths[month]
        }
      },

      // 月別販売数(副2)

      year1Sub2SellVolumeInMonth (month) {
        if (this.year1.sub2.sellVolumePerYear !== null) {
          // 年間
          return Math.round(this.year1.sub2.sellVolumePerYear / 12)
        } else {
          // 月別
          return this.year1.sub2.sellVolumePerMonths[month]
        }
      },

      year2Sub2SellVolumeInMonth (month) {
        if (this.year2.sub2.sellVolumePerYear !== null) {
          // 年間
          return Math.round(this.year2.sub2.sellVolumePerYear / 12)
        } else {
          // 月別
          return this.year2.sub2.sellVolumePerMonths[month]
        }
      },

      year3Sub2SellVolumeInMonth (month) {
        if (this.year3.sub2.sellVolumePerYear !== null) {
          // 年間
          return Math.round(this.year3.sub2.sellVolumePerYear / 12)
        } else {
          // 月別
          return this.year3.sub2.sellVolumePerMonths[month]
        }
      },

      // 月別売上原価(主)

      beforeMainSalesCostInMonth (month) {
        return 0
      },

      year1MainSalesCostInMonth (month) {
        if (this.year1.main.productCostPerItem !== null) {
          // 1個あたり
          return this.year1.main.productCostPerItem * this.year1MainSellVolumeInMonth(month)
        } else if (this.year1.main.productCostPerYear !== null) {
          // 年別
          return Math.round(this.year1.main.productCostPerYear / 12)
        } else {
          // 月別
          return this.year1.main.productCostPerMonths[month]
        }
      },

      year2MainSalesCostInMonth (month) {
        if (this.year2.main.productCostPerItem !== null) {
          // 1個あたり
          return this.year2.main.productCostPerItem * this.year2MainSellVolumeInMonth(month)
        } else if (this.year2.main.productCostPerYear !== null) {
          // 年別
          return Math.round(this.year2.main.productCostPerYear / 12)
        } else {
          // 月別
          return this.year2.main.productCostPerMonths[month]
        }
      },

      year3MainSalesCostInMonth (month) {
        if (this.year3.main.productCostPerItem !== null) {
          // 1個あたり
          return this.year3.main.productCostPerItem * this.year3MainSellVolumeInMonth(month)
        } else if (this.year3.main.productCostPerYear !== null) {
          // 年別
          return Math.round(this.year3.main.productCostPerYear / 12)
        } else {
          // 月別
          return this.year3.main.productCostPerMonths[month]
        }
      },

      // 月別売上原価(副)

      beforeSubSalesCostInMonth (month) {
        return 0
      },

      year1SubSalesCostInMonth (month) {
        if (this.year1.sub.productCostPerItem !== null) {
          // 1個あたり
          return this.year1.sub.productCostPerItem * this.year1SubSellVolumeInMonth(month)
        } else if (this.year1.sub.productCostPerYear !== null) {
          // 年別
          return Math.round(this.year1.sub.productCostPerYear / 12)
        } else {
          // 月別
          return this.year1.sub.productCostPerMonths[month]
        }
      },

      year2SubSalesCostInMonth (month) {
        if (this.year2.sub.productCostPerItem !== null) {
          // 1個あたり
          return this.year2.sub.productCostPerItem * this.year2SubSellVolumeInMonth(month)
        } else if (this.year2.sub.productCostPerYear !== null) {
          // 年別
          return Math.round(this.year2.sub.productCostPerYear / 12)
        } else {
          // 月別
          return this.year2.sub.productCostPerMonths[month]
        }
      },

      year3SubSalesCostInMonth (month) {
        if (this.year3.sub.productCostPerItem !== null) {
          // 1個あたり
          return this.year3.sub.productCostPerItem * this.year3SubSellVolumeInMonth(month)
        } else if (this.year3.sub.productCostPerYear !== null) {
          // 年別
          return Math.round(this.year3.sub.productCostPerYear / 12)
        } else {
          // 月別
          return this.year3.sub.productCostPerMonths[month]
        }
      },

      // 月別売上原価(副2)

      beforeSub2SalesCostInMonth (month) {
        return 0
      },

      year1Sub2SalesCostInMonth (month) {
        if (this.year1.sub2.productCostPerItem !== null) {
          // 1個あたり
          return this.year1.sub2.productCostPerItem * this.year1Sub2SellVolumeInMonth(month)
        } else if (this.year1.sub2.productCostPerYear !== null) {
          // 年別
          return Math.round(this.year1.sub2.productCostPerYear / 12)
        } else {
          // 月別
          return this.year1.sub2.productCostPerMonths[month]
        }
      },

      year2Sub2SalesCostInMonth (month) {
        if (this.year2.sub2.productCostPerItem !== null) {
          // 1個あたり
          return this.year2.sub2.productCostPerItem * this.year2Sub2SellVolumeInMonth(month)
        } else if (this.year2.sub2.productCostPerYear !== null) {
          // 年別
          return Math.round(this.year2.sub2.productCostPerYear / 12)
        } else {
          // 月別
          return this.year2.sub2.productCostPerMonths[month]
        }
      },

      year3Sub2SalesCostInMonth (month) {
        if (this.year3.sub2.productCostPerItem !== null) {
          // 1個あたり
          return this.year3.sub2.productCostPerItem * this.year3Sub2SellVolumeInMonth(month)
        } else if (this.year3.sub2.productCostPerYear !== null) {
          // 年別
          return Math.round(this.year3.sub2.productCostPerYear / 12)
        } else {
          // 月別
          return this.year3.sub2.productCostPerMonths[month]
        }
      },

      beforeTotalSalesCostInMonth (month) {
        return this.beforeMainSalesCostInMonth(month) + this.beforeSubSalesCostInMonth(month) + this.beforeSub2SalesCostInMonth(month)
      },

      year1TotalSalesCostInMonth (month) {
        return this.year1MainSalesCostInMonth(month) + this.year1SubSalesCostInMonth(month) + this.year1Sub2SalesCostInMonth(month)
      },

      year2TotalSalesCostInMonth (month) {
        return this.year2MainSalesCostInMonth(month) + this.year2SubSalesCostInMonth(month) + this.year2Sub2SalesCostInMonth(month)
      },

      year3TotalSalesCostInMonth (month) {
        return this.year3MainSalesCostInMonth(month) + this.year3SubSalesCostInMonth(month) + this.year3Sub2SalesCostInMonth(month)
      },

      // 月別販売管理費合計

      beforeSalesManagementCostInMonth (month) {
        // 販売前広告費投入月チェック
        if (this.beforeMonths - this.before.advertisingStartMonth <= month) {
          const ad = this.beforeAdvertisingExpense / (this.before.advertisingStartMonth || 1)
          return Math.round((this.beforePersonnelExpense + this.beforeLifeExpense + this.beforeOtherExpense) / this.beforeMonths + ad)
        } else {
          return Math.round((this.beforePersonnelExpense + this.beforeLifeExpense + this.beforeOtherExpense) / this.beforeMonths)
        }
      },

      year1SalesManagementCostInMonth (month) {
        return Math.round(this.year1SalesManagementCost / 12)
      },

      year2SalesManagementCostInMonth (month) {
        return Math.round(this.year2SalesManagementCost / 12)
      },

      year3SalesManagementCostInMonth (month) {
        return Math.round(this.year3SalesManagementCost / 12)
      },

      beforeSalesManagementCostInMonthForFunds (month) {
        return this.beforeSalesManagementCostInMonth(month) + (this.beforeInvestmentCostForFunds / this.beforeMonths)
      },

      year1SalesManagementCostInMonthForFunds (month) {
        return Math.round(this.year1SalesManagementCostForFunds / 12)
      },

      year2SalesManagementCostInMonthForFunds (month) {
        return Math.round(this.year2SalesManagementCostForFunds / 12)
      },

      year3SalesManagementCostInMonthForFunds (month) {
        return Math.round(this.year3SalesManagementCostForFunds / 12)
      },

      // 月別営業利益

      beforeOperatingProfitTotalInMonth (month) {
        return this.beforeTotalSalesInMonth(month) - this.beforeTotalSalesCostInMonth(month) - this.beforeSalesManagementCostInMonth(month)
      },

      year1OperatingProfitTotalInMonth (month) {
        return this.year1TotalSalesInMonth(month) - this.year1TotalSalesCostInMonth(month) - this.year1SalesManagementCostInMonth(month)
      },

      year2OperatingProfitTotalInMonth (month) {
        return this.year2TotalSalesInMonth(month) - this.year2TotalSalesCostInMonth(month) - this.year2SalesManagementCostInMonth(month)
      },

      year3OperatingProfitTotalInMonth (month) {
        return this.year3TotalSalesInMonth(month) - this.year3TotalSalesCostInMonth(month) - this.year3SalesManagementCostInMonth(month)
      },

      beforeOperatingProfitTotalInMonthForFunds (month) {
        return this.beforeTotalSalesInMonth(month) - this.beforeTotalSalesCostInMonth(month) - this.beforeSalesManagementCostInMonthForFunds(month)
      },

      year1OperatingProfitTotalInMonthForFunds (month) {
        return this.year1TotalSalesInMonth(month) - this.year1TotalSalesCostInMonth(month) - this.year1SalesManagementCostInMonthForFunds(month)
      },

      year2OperatingProfitTotalInMonthForFunds (month) {
        return this.year2TotalSalesInMonth(month) - this.year2TotalSalesCostInMonth(month) - this.year2SalesManagementCostInMonthForFunds(month)
      },

      year3OperatingProfitTotalInMonthForFunds (month) {
        return this.year3TotalSalesInMonth(month) - this.year3TotalSalesCostInMonth(month) - this.year3SalesManagementCostInMonthForFunds(month)
      },

      // 月別営業利益

      salesPerMonths () {
        const beforeSales = _.times(this.beforeMonths, (i) => this.beforeTotalSalesInMonth(i))
        const year1Sales = _.times(12, (i) => this.year1TotalSalesInMonth(i))
        const year2Sales = _.times(12, (i) => this.year2TotalSalesInMonth(i))
        const year3Sales = _.times(12, (i) => this.year3TotalSalesInMonth(i))
        return _.concat(beforeSales, year1Sales, year2Sales, year3Sales)
      },

      operatingProfitsPerMonths () {
        const beforeOperatingProfits = _.times(this.beforeMonths, (i) => this.beforeOperatingProfitTotalInMonth(i))
        const year1OperatingProfits = _.times(12, (i) => this.year1OperatingProfitTotalInMonth(i))
        const year2OperatingProfits = _.times(12, (i) => this.year2OperatingProfitTotalInMonth(i))
        const year3OperatingProfits = _.times(12, (i) => this.year3OperatingProfitTotalInMonth(i))
        return _.concat(beforeOperatingProfits, year1OperatingProfits, year2OperatingProfits, year3OperatingProfits)
      },

      operatingProfitsPerMonthsForFunds () {
        const beforeOperatingProfits = _.times(this.beforeMonths, (i) => this.beforeOperatingProfitTotalInMonthForFunds(i))
        const year1OperatingProfits = _.times(12, (i) => this.year1OperatingProfitTotalInMonthForFunds(i))
        const year2OperatingProfits = _.times(12, (i) => this.year2OperatingProfitTotalInMonthForFunds(i))
        const year3OperatingProfits = _.times(12, (i) => this.year3OperatingProfitTotalInMonthForFunds(i))
        return _.concat(beforeOperatingProfits, year1OperatingProfits, year2OperatingProfits, year3OperatingProfits)
      },

      sellVolumesPerMonths () {
        let before = _.times(this.beforeMonths, (i) => 0)
        let year1SellVolumes = _.times(12, (i) => this.year1MainSellVolumeInMonth(i) + this.year1SubSellVolumeInMonth(i) + this.year1Sub2SellVolumeInMonth(i))
        let year2SellVolumes = _.times(12, (i) => this.year2MainSellVolumeInMonth(i) + this.year2SubSellVolumeInMonth(i) + this.year2Sub2SellVolumeInMonth(i))
        let year3SellVolumes = _.times(12, (i) => this.year3MainSellVolumeInMonth(i) + this.year3SubSellVolumeInMonth(i) + this.year3Sub2SellVolumeInMonth(i))
        return _.concat(before, year1SellVolumes, year2SellVolumes, year3SellVolumes)
      },

      // 単月黒字になる月(販売開始前月からの経過月)を返す
      // 見つからない場合は null
      findSurplusMonth () {
        const i = _.findIndex(this.operatingProfitsPerMonths(), (profit) => profit > 0)
        return i !== -1 ? i : null
      },

      findSurplusMonthForFunds () {
        const i = _.findIndex(this.operatingProfitsPerMonthsForFunds(), (profit) => profit > 0)
        return i !== -1 ? i : null
      },

      // 累積黒字になる月(販売開始前月からの経過月)を返す
      // 見つからない場合は null
      findCumulativeSurplusMonth () {
        // 累積営業利益
        const accumulated = _.reduce(this.operatingProfitsPerMonths(), (r, a, i) => {
          const subtotal = (i && r[i - 1]) || 0
          const total = subtotal + a
          r.push(total)
          return r
        }, [])
        const i = _.findIndex(accumulated, (profit) => profit >= 0)
        return i !== -1 ? i : null
      },

      findCumulativeSurplusMonthForFunds () {
        // 累積営業利益
        const accumulated = _.reduce(this.operatingProfitsPerMonthsForFunds(), (r, a, i) => {
          const subtotal = (i && r[i - 1]) || 0
          const total = subtotal + a
          r.push(total)
          return r
        }, [])
        const i = _.findIndex(accumulated, (profit) => profit >= 0)
        return i !== -1 ? i : null
      },

      // 累積赤字が最大になる月を返す
      // 見つからない場合は null
      findCumulativeMaxShortageMonth () {
        // 累積営業利益
        const accumulated = _.reduce(this.operatingProfitsPerMonths(), (r, a, i) => {
          const subtotal = (i && r[i - 1]) || 0
          const total = subtotal + a
          r.push(total)
          return r
        }, [])
        const i = accumulated.indexOf(Math.min(...accumulated))
        return i !== -1 ? i : null
      },

      findCumulativeMaxShortageMonthForFunds () {
        // 累積営業利益
        const accumulated = _.reduce(this.operatingProfitsPerMonthsForFunds(), (r, a, i) => {
          const subtotal = (i && r[i - 1]) || 0
          const total = subtotal + a
          r.push(total)
          return r
        }, [])
        const i = accumulated.indexOf(Math.min(...accumulated))
        return i !== -1 ? i : null
      },
      currencyFormat (val, fixed = 1, negativeMark = '△') {
        try {
          const num = parseInt(val, 10)
          if (isNaN(num)) {
            return val
          }
        } catch (error) {
          return val
        }

        const delimiterFormat = /\B(?=(\d{3})+(?!\d))/g
        if (val >= 0) {
          return val.toFixed(fixed).replace(delimiterFormat, ',')
        } else {
          return negativeMark + ' ' + Math.abs(val).toFixed(fixed).toString().replace(delimiterFormat, ',')
        }
      }
    }
  }

</script>
